<template lang="html">

  <section class="wrapper cv-area">

    <div class="container">


      <h2 class="title-section">
        <span @click="toggleedit">Documentación</span>
        <template v-if="!noedit">
          <button @click="showedit= true" class="cv-action-button edit" v-if="!showedit"></button>
          <button @click="showedit= false" class="cv-action-button close" v-else>✕</button>
          <popup-info :texto="'info_cv'" :toright="true" :side="'left'"></popup-info>
        </template>
      </h2>

      <div class="contenedor-documentos" :canerase="showedit" v-if="!!cvdata">
        <p class="descargable" v-for="(doc,key) in cvdata">
          <a @click="eraseDoc(doc.id)" class="erase"></a>
          <a class="doclink" :href="doc.enlace" target="_blank">{{doc.fecha}} -
            {{doc.nombre}}</a>
        </p>
      </div>

      <p v-if="!!!cvdata & !noedit & !showedit" class="-mb15">No tienes ningún documento añadido pulsa
        en <a @click="showedit= true">editar</a> para añadirlo</p>

      <p v-if="!!!cvdata & noedit" class="-mb15">Sin documentos añadidos</p>

      <button @click="shownew= true" v-if="showedit && !shownew" class="btn">Añadir
        nuevo</button>

      <div class="upload-wrapper" v-if="shownew">

        <div class="contenedor-input">
          <label for="">Tipo de archivo</label>
          <select name="tipodocumento" v-model="actualDoc.tipo">
            <option value="">Selecciona un tipo</option>
            <option :value="doc[0]" v-for="(doc, key) in docstypes">{{doc[1]}}</option>
            <option :value="'otro'">Otro documento</option>
          </select>
        </div>

        <div class="contenedor-input" v-if="actualDoc.tipo == 'otro'">
          <label for="">Nombre del fichero</label>
          <input type="text" v-model="actualDoc.nombre">
        </div>

        <dropzone @emit="setDoc" ref="dropzone" v-if="!!actualDoc.tipo"></dropzone>
        <div class="contenedor-botones row-start" v-if="shownew">
          <button class="btn" v-if="!!actualDoc.tipo &&
            actualDoc.ficheroB64ParaAltas" @click="send" :loading="loading">Guardar</button>
          <button class="btn -skull" @click="closeedit">Cancelar</button>
        </div>

      </div>


    </div>

  </section>

</template>

<script lang="js">

  import { mapActions, mapGetters } from 'vuex';

  import popupInfo from '@/components/parts/popup-info';
  import dropzone from '@/components/parts/dropzone';

  export default {
    name: 'documentacion',
    props: ['cvdata', 'noedit'],
    data() {
      return {
        showedit: false,
        shownew: false,
        loading: false,
        actualDoc: {
          "id": "",
          "fecha": "",
          "tipo": "",
          "enlace": "",
          "nombre": "",
          "ficheroB64ParaAltas": "",
          "extension_adjunto": "",
          "idDocumentoNecesarioOfertaNoTipado": 0
        }
      }
    },
    methods: {
      ...mapActions(['addDoc', 'eraseDoc']),
      toggleedit() {
        if (!this.noedit) {
          this.showedit = !this.showedit
        }
      },
      closeedit() {
        this.shownew = false;
        this.showedit = false;
      },
      setDoc(value) {
        for (let i in value) {
          if (i != 'nombre' || this.actualDoc.tipo != 'otro') { 
            this.actualDoc[i] = value[i];
          }
        }
      },
      send() {
        this.loading = true;

        if (this.actualDoc.tipo == 'otro') {
          this.actualDoc.tipo = null;
        }

        this.addDoc(this.actualDoc).then(r => {
          if (r) {
            this.reset();
          }
        }).finally(e => {
          this.loading = false;
        });
      },
      reset() {

        for (let i in this.actualDoc) {
          this.actualDoc[i] = '';
        }

        this.showedit = false;
        this.shownew = false;

      }
    },
    computed: {
      ...mapGetters({
        dominios: 'getDominiosOrder',
        isEstudiante: 'isEstudiante',
        isAlumni: 'isAlumni'
      }),
      docstypes() {
        let docs = (this.isAlumni) ? this.dominios.tiposDocumentoAlumnoEmpleo : this.dominios.tiposDocumentoAlumnoPracticas;
        return docs;
      }
    },
    components: {
      'popup-info': popupInfo,
      'dropzone': dropzone
    },
    watch: {
      'showedit'() {
        if (this.showedit & !!!this.cvdata) {
          this.shownew = true;
        }
      }
    }
  }
</script>

<style scoped lang="scss">
</style>


// WEBPACK FOOTER //
// src/components/view-parts/espacio-personal/documentacion.vue